import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import genreList from '@/js/data/genre';
import { prefectures as prefectureList } from '@/js/data/area';
import IModal from '@/js/components/molecules/IModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'filter-sort',
  props: {
    initialPeriod: { default: '' },
    initialGenres: { default: () => [] },
    initialPrefecture: { default: undefined },
    initialSort: { default: 'new' }
  },
  setup(__props: any) {

const props = __props as { initialPeriod: string, initialGenres: string[], initialPrefecture: string, initialSort: string };


const isFilterShow = ref(false);
const isSortShow = ref(false);
const period = ref(props.initialPeriod);
const genres = ref(props.initialGenres);
const prefecture = ref(props.initialPrefecture);
const sort = ref(props.initialSort);
const filterLabel = computed(() => {
  const conditionCount = (period.value === undefined ? 0 : 1) + genres.value.length + (prefecture.value === undefined ? 0 : 1);
  let label = '絞り込み';
  if (conditionCount > 0) {
    label += ` (${conditionCount})`;
  }
  return label;
});
const sortLabel = computed(() => (sort.value === 'ending' ? '終了日順' : '新着順'));
const queryString = computed(() => {
  const url = new URLSearchParams();

  if (period.value) {
    url.append('period', period.value);
  }
  if (genres.value.length > 0) {
    url.append('genre', genres.value.join(','));
  }
  if (prefecture.value) {
    url.append('prefecture', prefecture.value);
  }
  if (sort.value !== 'new') {
    url.append('sort', sort.value);
  }

  return url.toString();
});
const onClickOpenFilter = () => {
  isFilterShow.value = true;
  isSortShow.value = false;
};
const onClickResetFilter = () => {
  period.value = undefined;
  genres.value = [];
  prefecture.value = undefined;
};
const onClickSubmitFilter = () => {
  window.location.href = `?${queryString.value}`;
};
const onClickGenreItem = (slug: string) => {
  const index = genres.value.indexOf(slug);

  if (index === -1) {
    genres.value.push(slug);
  } else {
    genres.value.splice(index, 1);
  }
};
const onClickToggleSort = () => {
  isSortShow.value = !isSortShow.value;
  isFilterShow.value = false;
};
const onClickSortItem = (tmpSort: string) => {
  sort.value = tmpSort;
  isSortShow.value = false;
  window.location.href = `?${queryString.value}`;
};

return { __sfc: true,props, isFilterShow, isSortShow, period, genres, prefecture, sort, filterLabel, sortLabel, queryString, onClickOpenFilter, onClickResetFilter, onClickSubmitFilter, onClickGenreItem, onClickToggleSort, onClickSortItem, genreList, prefectureList, IModal }
}

})